import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

import { listOperationPackages } from "./-query/api";

/**
 * IT Operation Coreのパッケージ一覧のはじめの有効なパッケージに遷移するためのエントリポイント。
 * パッケージ一覧の表示は、`/it-operation-core/packages`で行う。
 * パッケージの詳細な表示は、`/it-operation-core/packages/$packageId`で行う。
 */
export const Route = createFileRoute(
  "/_staff/it-operation-core/_root/packages/",
)({
  loader: listOperationPackages,
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  const packages = Route.useLoaderData();

  // 初期化時にグループの最初のパッケージに遷移する
  useEffect(() => {
    if (packages.apps.length > 0) {
      navigate({
        to: "/it-operation-core/packages/$packageId",
        params: { packageId: packages.apps[0].id },
      });
    }
  }, [packages, navigate]);

  return null;
}
